<template>
  <v-layout row>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="close">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="success"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12 sm4 offset-sm4>
      <v-card class="mt-5">
        <v-toolbar color="error" dark>
          <v-toolbar-title class="headline"> Verify pin </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row>
                <v-text-field
                  v-model="insertItem.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field
                  v-model="insertItem.token"
                  type="text"
                  :rules="tokenRules"
                  label="Token"
                  required
                ></v-text-field>
              </v-layout>
              <v-layout>
                <v-btn color="error" @click="reset">Clear</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="success" @click="save">submit</v-btn>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { ROOT_URL } from "@/api/connectingUrls";
import router from "../../router";
export default {
  data: () => ({
    error: 0,
    errorMsg: "",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 3000,
    valid: true,
    apiUrl: "verify/pin",
    insertItem: {
      email: "",
      token: "",
    },
    defaultItem: {
      email: "",
      token: "",
    },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    tokenRules: [
      (v) => !!v || "Token is required",
      (v) => (v && v.length == 6) || "Token must be in 6 characters",
    ],
  }),
  created() {
    this.insertItem.email = this.$route.params.email;
  },
  methods: {
    close() {
      this.error = false;
      this.snackbar = false;
      setTimeout(() => {
        this.insertItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      // console.log(this.insertItem);
      try {
        return axios
          .post(`${ROOT_URL}/${this.apiUrl}`, this.insertItem, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.error == 0) {
              this.errorMsg = response.data.errorMsg;
              this.snackbar = true;
              setTimeout(() => {
                this.$router.push({
                  name: "reset-password",
                  params: { email: this.insertItem.email },
                });
              }, 300);
            } else {
              this.error = response.data.error;
              this.errorMsg = response.data.errorMsg;
            }
          });
      } catch (error) {
        // console.log(error);
      }
      this.close();
    },
  },
};
</script>
